import { render, staticRenderFns } from "./RetirmentCalculator.vue?vue&type=template&id=8322892a&scoped=true"
import script from "./RetirmentCalculator.vue?vue&type=script&lang=js"
export * from "./RetirmentCalculator.vue?vue&type=script&lang=js"
import style0 from "./RetirmentCalculator.vue?vue&type=style&index=0&id=8322892a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8322892a",
  null
  
)

export default component.exports